// All needed imports
import { Numbers, commondSelectOptionsList } from 'src/app/utils/constants';
import { formConfigCommond } from 'src/app/utils/form.utils';
import { commonParticularDataLegal, setDateFormConfig } from 'src/app/utils/form-utils-extended';
import { CalendarBaseModel } from 'src/app/core/models/calendar-base.model';
import { setBtnTooltip, setSelectModel, setSelectOptions, setSelectValue } from 'src/app/utils/labels.utils';
import { SelectModel } from 'src/app/core/models/select.model';

/**
 * set the LITERAL_TEXT value with the form3 value
 * The value is particularTravelAsistance
 */
const LITERAL_TEXT = 'particularTravelAsistance';
const DATE = new CalendarBaseModel(setDateFormConfig(LITERAL_TEXT));

// PARTICULAR_DATA object
const PARTICULAR_DATA = {
  ...commonParticularDataLegal(LITERAL_TEXT, DATE, 'form3'),

  // Override insuredOlderThan70years to use form3-specific tooltip (max age 90 years for AVP)
  insuredOlderThan70years: new SelectModel(
    setSelectModel([LITERAL_TEXT, 'insuredOlderThan70years'],
      setSelectValue('form3.old-70', 'form3.old-70.error', 'label_size_7'),
      setSelectOptions('', '', commondSelectOptionsList),
      setBtnTooltip('icon icon-info', 'form3.old-70-tooltip')
    )
  ),

  petInsureds: new SelectModel(
    setSelectModel([LITERAL_TEXT, 'petInsureds'],
      setSelectValue('form1.petInsureds', 'form1.petInsureds.error', 'label_size_7'),
      setSelectOptions('', '', [{ name: '1', id: Numbers.number1 }, { name: '2', id: Numbers.number2 },
        { name: '3', id: Numbers.number3 }]),
      setBtnTooltip('icon icon-info', 'form1.petInsureds-tooltip')
    )
  )
};

/**
 * Export the obj to be used in the angular components app
 */
export const FORM_CONFIG = {
  ...formConfigCommond(LITERAL_TEXT, Numbers.number6),
  ...PARTICULAR_DATA
};
